
import {
  computed, defineComponent, inject, onMounted, Ref, ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AppNavigation from '@/components/AppNavigation.vue';
import SpacesPopUp from '../components/SpacesPopUp.vue';
import { APPLICATION_SETTINGS_TYPE, NAVIGATION_PAGES, REGISTRATION_GROUP } from '@/types/enums';
import AppHeader from '@/components/AppHeader.vue';
import AppSearch from '@/components/UI/AppSearch.vue';
// eslint-disable-next-line import/no-cycle
import { useSpacesStore } from '../store/spacesStore';
// eslint-disable-next-line import/no-cycle
import {
  IGroupEmit, INavigation, IRegistrationGroupData, IUpdateGroupData,
} from '@/types/interfaces';
import AddGroupImage from '@/modules/spaces/components/AddGroupImage.vue';
// eslint-disable-next-line import/no-cycle
import SpacesService from '@/modules/spaces/services/SpacesService';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import AddGroup from '@/modules/spaces/components/AddGroup/AddGroup.vue';
import AppBetaUserPopUp from '@/components/AppBetaUserPopUp.vue';
import DesktopHeader from '@/components/desktop/DesktopHeader.vue';
import DriveAsideMainMenu from '@/modules/drive/components/desktop/DriveAsideMainMenu.vue';
import AppNoMessage from '@/components/AppNoMessage.vue';

export default defineComponent({
  components: {
    AppNoMessage,
    DesktopHeader,
    AppNavigation,
    SpacesPopUp,
    // AppAddButton,
    AppHeader,
    AppSearch,
    AddGroupImage,
    AddGroup,
    AppBetaUserPopUp,
    DriveAsideMainMenu,
    // SpacesManagePopUp,
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const spacesStore = useSpacesStore();
    const mainStore = useMainStore();
    const showPopUp: Ref<boolean> = ref(false);
    // const showManagePopUp: Ref<boolean> = ref(false);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localizeIfPresent = inject('$localizeIfPresent') as Function;

    const groupCreate = ref();

    const hideAppButton = computed(() => route.meta?.hideAppButton);
    const hideBottomNav = computed(() => route.meta?.hideBottomNav);
    const navigationPage = computed(() => route.meta?.navigationPage);
    const hideHeader = computed(() => route.meta?.hideHeader);
    const hideSearch = computed(() => route.meta?.hideHeaderSearch);
    const showGroupImage = computed(() => route.meta?.showGroupImage);
    const backArrow = computed(() => route.meta?.backArrow);
    const backText = computed(() => $localize(route.meta?.backText));
    const isManageContacts = computed(
      () => mainStore.applicationSettings.find((feature) => feature.name === APPLICATION_SETTINGS_TYPE.CONTACT_NETWORKING_FEATURE)?.enabled,
    );
    // const groupTitle = computed(() => {
    //
    // });

    const registrationGroupData: Ref<IRegistrationGroupData> = ref({} as IRegistrationGroupData);
    const updateGroupData: Ref<IUpdateGroupData> = ref({} as IUpdateGroupData);

    const showManage = computed(() => spacesStore.myContacts.length
      && (navigationPage.value === NAVIGATION_PAGES.SPACES_CONTACTS
        || navigationPage.value === NAVIGATION_PAGES.SPACES_SETTLE));

    const showDone = computed(() => navigationPage.value === NAVIGATION_PAGES.SPACES_MANAGE
      || (navigationPage.value === NAVIGATION_PAGES.SPACES_GROUPS
        && spacesStore.usersToAdd.length
        && NAVIGATION_PAGES.SPACES_GROUPS_EDIT));

    const currentIcon = computed(() => {
      switch (route.meta?.navigationPage) {
        case NAVIGATION_PAGES.SPACES_CONTACTS:
          return 'icon-user-add';
        case NAVIGATION_PAGES.SPACES_GROUPS_MAIN:
          return 'icon-group-add';
        default:
          return '';
      }
    });

    const noDataMessage = computed(() => ({
      text: $localize('no.search.results'),
      icon: 'icon-not-found',
    }));

    const searchPlaceholder = computed(() => {
      switch (route.meta?.navigationPage) {
        case NAVIGATION_PAGES.SPACES_CONTACTS:
          return 'contacts.placeholder.search';
        case NAVIGATION_PAGES.SPACES_GROUPS_MAIN:
          return 'groups.placeholder.search';
        default:
          return 'placeholder.search';
      }
    });

    const navigationData = computed<INavigation[]>(() => [
      {
        label: 'contacts.toggle.contacts',
        routeTo: 'contacts',
        activePage: NAVIGATION_PAGES.SPACES_CONTACTS,
        badges: mainStore.badgesContact,
      },
      {
        label: 'contacts.toggle.groups',
        routeTo: 'groups',
        activePage: NAVIGATION_PAGES.SPACES_GROUPS_MAIN,
        badges: mainStore.badgesGroup + mainStore.badgesInGroup,
      },
    ]);

    function backAction() {
      switch (route.meta?.navigationPage) {
        case NAVIGATION_PAGES.SPACES_CONTACTS:
          router.push('/');
          break;
        default:
          router.back();
          break;
      }
    }

    function addUsersToGroup() {
      const payload = spacesStore.usersToAdd;
      SpacesService.addContactsToGroup(updateGroupData.value.id, payload).then((response) => {
        if (response) {
          router.push(`spaces/groups/group/${updateGroupData.value.id}`);
        }
      });
    }

    function onDone() {
      if (navigationPage.value === NAVIGATION_PAGES.SPACES_MANAGE) {
        router.push('contacts');
      } else {
        addUsersToGroup();
      }
    }

    function onAddButtonClick() {
      if (navigationPage.value === NAVIGATION_PAGES.SPACES_GROUPS_MAIN) {
        // router.push('groups/add-name');
        groupCreate.value.openDialog();
      } else {
        showPopUp.value = true;
      }
    }

    function createGroup() {
      const payload = { ...registrationGroupData.value, ownerId: mainStore.user.accountId, photo: null };
      SpacesService.createGroup(payload).then((res) => {
        if (res.success) {
          updateGroupData.value.name = res.results.data.name;
          updateGroupData.value.id = res.results.data.id;
          router.push('add-info');
        }
      });
    }

    function updateGroupInfo() {
      const payload = { ...updateGroupData.value, photo: null };
      SpacesService.updateGroup(payload).then((res) => {
        if (res.success) {
          router.push('add-settings');
        }
      });
    }

    function updateGroupSettings() {
      const payload = { ...updateGroupData.value, photo: null };
      SpacesService.updateGroup(payload).then((res) => {
        if (res.success) {
          router.push('add-members');
        }
      });
    }

    function editGroup() {
      const groupId = route.params.id;
      router.push(`/spaces/groups/group/edit/${groupId}`);
    }

    function addDataToGroup(data: IGroupEmit) {
      switch (data.type) {
        case REGISTRATION_GROUP.ADD_NAME:
          registrationGroupData.value.name = data.value;
          createGroup();
          break;
        case REGISTRATION_GROUP.ADD_INFO:
          updateGroupData.value.groupInfo = data.value;
          updateGroupInfo();
          break;
        case REGISTRATION_GROUP.ADD_SETTINGS:
          updateGroupData.value.groupType = data.value;
          updateGroupSettings();
          break;
        default:
          break;
      }
    }

    onMounted(() => {
      mainStore.badgesAlert = 0;
    });

    return {
      onAddButtonClick,
      addDataToGroup,
      spacesStore,
      route,
      hideHeader,
      hideAppButton,
      hideBottomNav,
      currentIcon,
      searchPlaceholder,
      showPopUp,
      navigationPage,
      NAVIGATION_PAGES,
      navigationData,
      backArrow,
      backText,
      hideSearch,
      showGroupImage,
      isManageContacts,
      backAction,
      onDone,
      showDone,
      showManage,
      editGroup,
      updateGroupData,
      // showManagePopUp,

      groupCreate,
      mainStore,
      noDataMessage,
    };
  },

});
